import { useMutation } from 'react-query'

import { ErrorResponse } from 'services/error-response'
import httpClient from 'services/http-client'
import { queryClient } from 'services/query-client'

import { GET_ALL_FAVOURITE_BRANDS } from './use-get-all-favourite-brands'

const setFavouriteBrand = async (key: string) =>
  httpClient.put(GET_ALL_FAVOURITE_BRANDS, {
    key,
  })

export const usePutFavouriteBrand = (onSuccess: () => void, onError: (data: ErrorResponse) => void) =>
  useMutation(setFavouriteBrand, {
    onSuccess: () => {
      void queryClient.fetchQuery({ queryKey: [GET_ALL_FAVOURITE_BRANDS] })
      onSuccess()
    },
    onError,
  })
